import { FileVideoIcon, PlusIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface ProcedureNoSourcesEmptyStateProps {
    onAddSource: () => void;
}

export function ProcedureNoSourcesEmptyState({
    onAddSource,
}: ProcedureNoSourcesEmptyStateProps) {
    const { t } = useTranslation(I18nNamespace.REPORTS);

    return (
        <div className="flex flex-1 min-h-[420px] items-center justify-center py-12 border border-grey-500 rounded-lg">
            <div className="w-full max-w-lg rounded-xl px-8 py-12 flex flex-col items-center text-center gap-6">
                <div className="flex flex-col items-center gap-2">
                    <FileVideoIcon
                        className="w-10 h-10 text-grey-200"
                        weight="fill"
                    />
                    <h2 className="text-lg text-grey-200">
                        {t('detail.noSources')}
                    </h2>
                    <p className="text-sm text-grey-300 max-w-sm">
                        {t('detail.emptyProcedureReportDescription')}
                    </p>
                </div>
                <Button
                    variant="primary"
                    size="medium"
                    leadingIcon={<PlusIcon className="size-4" />}
                    data-testid="procedure-report-empty-state-add-source"
                    onClick={onAddSource}
                >
                    {t('detail.addSource')}
                </Button>
            </div>
        </div>
    );
}
